import React, { Suspense } from 'react';
import AppRoutes from './routes/AppRoutes.jsx';
import { disableReactDevTools } from '@fvilers/disable-react-devtools';
import { createRoot } from 'react-dom/client';
import AppProvider from './AppProvider.jsx';
import { AppNotificationProvider } from '../utils/helpers/AppNotificationProvider.jsx';
import NotifierRegistrar from '../utils/helpers/NotifierRegistrar.jsx';

if (import.meta.env.MODE === 'production') {
  disableReactDevTools();
}

// unload event is used to signal the browser that bfCache should not be used
// there is some issue with bfCache, when user clicks back button and the page is restored from bfcache,
// the page is not functioning properly, this issue is only in firefox
if (navigator.userAgent.toLowerCase().includes('firefox')) {
  window.addEventListener('unload', () => {});
}

// After a new deployment, old chunks are removed from /build. An open tab that
// fails to load such a chunk is reloaded once to get the current build.
const PRELOAD_RELOAD_KEY = 'vite-preload-error-reload';
const PRELOAD_RELOAD_GAP_MS = 10 * 1000;

window.addEventListener('vite:preloadError', (event) => {
  try {
    const lastReload = Number(sessionStorage.getItem(PRELOAD_RELOAD_KEY));
    if (lastReload && Date.now() - lastReload < PRELOAD_RELOAD_GAP_MS) {
      return; // prevent reload loop, let the error surface
    }
    sessionStorage.setItem(PRELOAD_RELOAD_KEY, String(Date.now()));
  } catch (_) {
    // sessionStorage unavailable, reload anyway
  }

  event.preventDefault();
  window.location.reload();
});

const container = document.getElementById('app');
const root = createRoot(container);
root.render(
  <AppNotificationProvider>
    <Suspense fallback="">
      <AppProvider />
    </Suspense>
    <NotifierRegistrar />
  </AppNotificationProvider>,
);
